<template>
  <q-modal v-model="showLogin" :no-esc-dismiss="true"  :no-backdrop-dismiss="true">
    <!--<div v-if="user && user.subscription_status === 150 && getSuspendMessage()"></div>
     <div class="layout-padding">
         <div class="modal-close">
             <q-btn color="primary" round dense icon="close" @click="showLogin = false;$router.push('/')"></q-btn>
         </div>

         <div class="q-py-lg">

             <template v-if="!user">
                 <form @submit.prevent="login(slug)"
                       class="gutter-xs q-pa-xs"
                       @keydown="form.onKeydown($event)">

                     <div class="text-center"><img src="../../../img/identity/logo2.png" width="30%"/>
                     </div> -->

    <!-- Submit Button -->
    <!--    <div class="row justify-center">
            <v-submit :label="$t('log in')"
                      :loadingLabel="$t('validating...')"
                      color="primary"
                      :form="form">
            </v-submit>
        </div>

    </form>

    <template slot="actions">
        <q-btn flat color="highlight" @click="$router.push({ name: 'password.request' })"
               :label="$T('forgot your password?')"></q-btn>
    </template>
</template>

<div v-else class="q-pa-xl text-center">
    <div v-if="user.subscription_status === 150">
        <form @submit.prevent="redirectToWapBilling()"
              class="gutter-xs q-pa-xs"
              @keydown="form.onKeydown($event)">

            <div class="text-center"><img src="../../../img/identity/logo2.png"
                                          width="30%"/></div>
            <div v-html="suspendMessage"></div> -->
    <!-- Submit Button -->
    <!--  <div class="row justify-center">

      </div>

  </form>

</div>
<template v-else>

  {{ $T('you are logged in!') }}
</template>
</div>

</div>
</div>-->
  </q-modal>
</template>

<script>
import { mapGetters } from "vuex";
import Form from "vform";
import axios from "axios";
import {
  QModal,
  QSpinnerPuff,
  QBtn,
  QCheckbox,
  QInput
} from "quasar-framework";
import VInput from "../../components/form/VInput";

export default {
  name: "VSuspended",

  components: {
    VInput,
    QModal,
    QBtn,
    QSpinnerPuff,
    QCheckbox,
    QInput
  },

  data: () => ({
    form: new Form({
      email: "go4@test.com",
      password: "secret",
      remember: false,
      redirectTo: this.slug,
    }),
    suspendMessage: ""
  }),

  computed: {
    ...mapGetters({
      user: "auth/user",
      settings: "local/settings"
    }),
    showLogin: {
      get() {
        return this.settings("login");
      },
      set(value) {
        this.$store.dispatch("local/set", { key: "login", value });
      }
    },

    slug: {
      get() {
        return this.settings("redirect-route");
      },
      set(value) {
        this.$store.dispatch("local/set", { key: "redirect-route", value });
      }
    }
  },
  mounted() {
    //this.getSuspendMessage();
  },
  methods: {
    redirectToWapBilling() {
      axios.get(`${config.appUrl}/api/service-url`).then(({ data }) => {
        window.location.href = data;
      });
    },
    getSuspendMessage() {
      if (!localStorage.getItem('pop-up'))
        axios.get(`${config.appUrl}/api/suspend-message`)
            .then(({ data }) => {
              this.suspendMessage = data;
            })
            .finally(() => {
              if (!localStorage.getItem('pop-up')){
                this.$q.notify({
                  color: 'warning',
                  icon: 'warning',
                  message: this.suspendMessage,
                  position: 'top'
                })
                localStorage.setItem('pop-up', true)
                this.$router.push('/')
                this.time = setTimeout(function(){
                  localStorage.removeItem('pop-up')
                  clearTimeout()
                }.bind(this), 2000)
              }
            });
      else
        this.$router.push('/')
    },
    async login(slug) {
      this.form.redirectTo = slug !== undefined ? slug : "/";
      console.log(slug);
      // Submit the form.
      const { data } = await this.form.post(`${config.appUrl}/api/login`);
      window.location.href = data;

      // // Save the token.
      // this.$store.dispatch('auth/saveToken', {
      //     token: data.token,
      //     remember: this.form.remember
      // })
      //
      // // Fetch the user.
      // await this.$store.dispatch('auth/fetchUser')
      //
      // // Password expired?
      // // if (this.user.expiredPassword) {
      // //     this.$q.notify({
      // //         color: 'warning',
      // //         icon: 'warning',
      // //         message: this.$T('password expired'),
      // //         detail: this.$T('please, change your password.'),
      // //         position: 'top'
      // //     })
      // //     this.$router.push({name: 'settings.password'})
      // //     return
      // // }
      //
      // // reload da página autal.
      // this.$router.go()
    }
  }
};
// axios.get(`${config.appUrl}/api/sport/subscribe/1`)
//     .then(({data}) => {
//         window.location.href = data;
//
//     })
//     .catch(error => {
//         if (error.response && error.response.status == 404)
//             router.replace('/404')
//     })
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/auth/suspended.vue